import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSplitToSection({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="7" y="1" width="2" height="6" rx="1" fill="var(--marker-silverfish)"/>
            <rect x="7" y="9" width="2" height="6" rx="1" fill={fill}/>
        </svg>
    );
}

export default IconSplitToSection;
